module.exports = __webpack_public_path__ + "static/main-logo-benf-light-dfb090b6ba8b65d99ea8699d785732eb.svg";